import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';
import configData from '../configData.json';
import { formatInputDate, toLocalDate } from './Utlities';

export default function ImplementationModal(props) {


    const [locationNameOptions, setLocationNameOptions] = useState([]);
    const [selectedId, setSelectedId] = useState('');
    const [selectedLocationType, setSelectedLocationType] = useState(0);
    const [selectedLocationName, setSelectedLocationName] = useState(0);
    const [selectedServiceType, setSelectedServiceType] = useState(0);
    const [selectedFundingType, setSelectedFundingType] = useState(0);
    const [selectedSalesPerson, setSelectedSalesPerson] = useState(null);
    const [selectedContractCompleted, setSelectedContractCompleted] = useState(0);
    
    const [contractDate, setContractDate] = useState(null);
    const [selectedContractDate, setSelectedContractDate] = useState(null);

    const [selectedCreatedBy, setSelectedCreatedBy] = useState(null);
    const [selectedCreatedOn, setSelectedCreatedOn] = useState(null);
    const [selectedProjectedVolumes, setSelectedProjectVolumes] = useState(null);
    const [selectedSpendVolumes, setSelectedSpendVolumes] = useState(null);
    const [selectedServiceRegion, setSelectedServiceRegion] = useState(0);

    const [implementationDate, setImplementationDate] = useState(null);
    const [selectedImplementationStartDate, setSelectedImplementationStartDate] = useState(null);

    const [projectedProductionDate, setProjectedProductionDate] = useState(null);
    const [selectedProjectedProductionDate, setSelectedProjectedProductionDate] = useState(null);

    const [actualProductionDate, setActualProductionDate] = useState(null);
    const [selectedActualProductionDate, setSelectedActualProductionDate] = useState(null);

    const [selectedModifiedBy, setSelectedModifiedBy] = useState(null);
    const [selectedModifiedOn, setSelectedModifiedOn] = useState(null);
    const [isHidden, setIsHidden] = useState(false);
    const [isContractDateDisabled, setIsContractDateDisabled] = useState(true);


    useEffect(() => {
        debugger; 
        document.getElementById("error").innerHTML = "";      
        if (props.locationName && Array.isArray(props.locationName)) {
            setLocationNameOptions(props.locationName);
            console.log(locationNameOptions);
        }
        if (props.detailData) {
            setSelectedId(props.detailData.id);
            setSelectedLocationType(props.detailData.locationType);
            setSelectedLocationName(props.detailData.locationKey);
            setSelectedServiceType(props.detailData.serviceType);
            setSelectedFundingType(props.detailData.fundingType);
            setSelectedSalesPerson(props.detailData.salesPerson);
            setSelectedContractCompleted(props.detailData.contractCompleted);

            setContractDate(toLocalDate(props.detailData.contractDate));
            setSelectedContractDate(props.detailData.contractDate);

            debugger;
            if (props.detailData.contractCompleted == 'NOOO') {
                setIsContractDateDisabled(true);
            }
            else {
                setIsContractDateDisabled(false);
            }
            setSelectedCreatedBy(props.detailData.createdBy);
            setSelectedCreatedOn(props.detailData.createdOn);
            setSelectedProjectVolumes(props.detailData.projectedVolume);
            setSelectedSpendVolumes(props.detailData.projectedVolumeSpend);
            setSelectedServiceRegion(props.detailData.serviceRegion);

            setImplementationDate(toLocalDate(props.detailData.implementationStartDate));
            setSelectedImplementationStartDate(props.detailData.implementationStartDate);

            setProjectedProductionDate(toLocalDate(props.detailData.projectedProductionDate));
            setSelectedProjectedProductionDate(props.detailData.projectedProductionDate);

            setActualProductionDate(toLocalDate(props.detailData.actualProductionDate));
            setSelectedActualProductionDate(props.detailData.actualProductionDate);

            setSelectedModifiedBy(props.detailData.modifiedBy);
            setSelectedModifiedOn(props.detailData.modifiedOn);
        }
    }, [props]);



    const LoadLocationName = async (custkey, locTypeCode) => {
        debugger;
        // isDivisionLoading(true);


        const URL = `${configData.BASE_APP_URL}Implementaion/GetLocationName/${custkey}/${locTypeCode}`;

        try {
            let locationNameOptions = [];
            if (["DIV", "REG", "BRA"].includes(locTypeCode)) {
                const response = await fetch(URL, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                });

                const data = await response.json();

                data.forEach((locationName) => {
                    const locname = {
                        "name": locationName.value,
                        "value": locationName.key
                    };
                    locationNameOptions.push(locname);
                });
            }

            const defaultLocName = {
                "name": "-- Select A Value --",
                "value": 0
            };

            locationNameOptions.unshift(defaultLocName);
            setLocationNameOptions(locationNameOptions);
        } catch (error) {
            console.error('Error loading location names:', error);
        } finally {
            // isDivisionLoading(false);
        }
    };

    const SaveData = async () => {
        // setLoading(true);
        try {
            debugger;

            // Assuming these are your state variables
            const setupData = [
                {
                    id: selectedId,
                    customerKey: props.detailData.customerKey,
                    locationType: selectedLocationType,
                    locationKey: selectedLocationName,
                    serviceType: selectedServiceType,
                    fundingType: selectedFundingType,
                    salesPerson: selectedSalesPerson,
                    contractCompleted: selectedContractCompleted,
                    contractDate: selectedContractDate,
                    projectedVolume: selectedProjectedVolumes === '' ? null : selectedProjectedVolumes,
                    projectedVolumeSpend: selectedSpendVolumes === '' ? null : selectedSpendVolumes,
                    serviceRegion: selectedServiceRegion,
                    implementationStartDate: selectedImplementationStartDate,
                    projectedProductionDate: selectedProjectedProductionDate,
                    actualProductionDate: selectedActualProductionDate,
                    createdBy: selectedCreatedBy,
                    createdOn: selectedCreatedOn,
                    modifiedBy: sessionStorage.getItem('my-username'),
                    modifiedOn: selectedModifiedOn,
                    dirtyFlag: selectedId === '' ? 'i' : 'u',
                },
            ];

            debugger;
            console.log(JSON.stringify(setupData));
            debugger;

            const URL = `${configData.BASE_APP_URL}Implementaion/SaveImplementionSetup`;
            const response = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: sessionStorage.getItem('my-token'),
                },
                body: JSON.stringify(setupData),
            });

            if (response.ok) {
                // Data saved successfully
                // LoadDetailData(selectedCust); // Reload data if needed
                window.alert('Data Saved Successfully');
                setIsHidden(true);
                props.onSave(true);

            } else {
                // Handle server error or failed save
                const errorData = await response.text();
                window.alert(errorData);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            // setLoading(false);
            // setHiddenExcel(true);
        }

    };

    function isValidDate(dayValue, monthValue, yearValue) {
        // debugger;
        monthValue = parseInt(monthValue, 10);
        const isValidDay = dayValue >= 1 && dayValue <= 31;
        const isValidMonth = monthValue >= 1 && monthValue <= 12;
        const isValidYear = yearValue >= 1000 && yearValue <= 9999;

        if (!isValidDay || !isValidMonth || !isValidYear) {
            return false;
        }

        if (monthValue === 2) {
            const isLeapYear = (yearValue % 4 === 0 && yearValue % 100 !== 0) || (yearValue % 400 === 0);
            const maxDays = isLeapYear ? 29 : 28;
            return dayValue <= maxDays;
        } else if ([4, 6, 9, 11].includes(monthValue)) {
            // debugger;
            return dayValue <= 30;
        } else {
            return dayValue <= 31;
        }
    }

    function validateDateInput(day, month, year, errorMessage) {
        const dateValue = day.value + month.value + year.value;

        if (dateValue.length === 0) {
            document.getElementById("error").innerHTML = `${errorMessage} is a required field.`;
            return false;
        }

        if (!isValidDate(day.value, month.value, year.value)) {
            document.getElementById("error").innerHTML = `Invalid ${errorMessage} Format, date should be MM/DD/YYYY`;
            return false;
        }

        return true;
    }


    const handleSave = () => {
        debugger;

        let days = document.getElementsByClassName('react-date-picker__inputGroup__day');
        let months = document.getElementsByClassName('react-date-picker__inputGroup__month');
        let years = document.getElementsByClassName('react-date-picker__inputGroup__year');

        if (selectedLocationType == 0) {
            document.getElementById("error").innerHTML = "Location Type is a required field.";
            return
        }
        if (selectedLocationName == 0) {
            document.getElementById("error").innerHTML = "Location Name is a required field.";
            return
        }
        if (selectedServiceType == 0) {
            document.getElementById("error").innerHTML = "Type of Service is a required field.";
            return
        }
        if (selectedFundingType == 0) {
            document.getElementById("error").innerHTML = "Funding Type is a required field.";
            return
        }
        if (selectedSalesPerson == null || selectedSalesPerson.length == 0) {
            document.getElementById("error").innerHTML = "Sales Person is a required field.";
            return
        }
        if (selectedContractCompleted == 0) {
            document.getElementById("error").innerHTML = "Contract Completed is a required field.";
            return
        }

        if (selectedContractCompleted == 'YESS') {
            if (!validateDateInput(days[0], months[0], years[0], "Contract Date")) {
                return;
            }
        }   
        if (selectedServiceRegion == 0) {
            document.getElementById("error").innerHTML = "Region of nVision Service is a required field.";
            return
        }
        
        SaveData();
        document.getElementById("error").innerHTML = '';

        // Call the onSave prop with the parameter isHidden
        // setIsHidden(true);
        // props.onSave(true);

        // Close the modal or perform other actions if needed

    };

    const handleCancel = () => {
        setIsHidden(true);
        props.onCancel(true);
    }


    const onLocationTypeSelect = (e) => {
        debugger;
        setSelectedLocationType(e);
        setSelectedLocationName(0);
        LoadLocationName(props.detailData.customerKey, e)
    };

    const onLocationNameSelect = (e) => {
        setSelectedLocationName(e);
    };

    const onServiceTypeSelect = (e) => {
        setSelectedServiceType(e);
    };

    const onFundingTypeSelect = (e) => {
        setSelectedFundingType(e);
    };

    const onSalesPersonChange = (e) => {
        const input = e.target.value;
        const onlyLettersAndSpace = input.replace(/[^a-zA-Z\s]/g, ''); // Remove non-letter characters except space

        setSelectedSalesPerson(onlyLettersAndSpace);
    };



    const onContractCompletedSelect = (e) => {
        debugger;
        if (e == 'NOOO' || e == 0) {
            setIsContractDateDisabled(true);
            setContractDate(null);
            setSelectedContractDate(null);
        }
        else {
            setIsContractDateDisabled(false);
        }

        setSelectedContractCompleted(e);

    };

    const onContractDateChanges = (e) => {
        debugger;

        setContractDate(e);
        setSelectedContractDate(formatInputDate(e));
    };

    const onProjectedVolumesChanges = (e) => {
        debugger;
        const numericValue = e.target.value.replace(/[^0-9]/g, '');
        setSelectedProjectVolumes(numericValue);
    };

    const onProjectedSpendChanges = (e) => {
        const numericValue = e.target.value.replace(/[^0-9]/g, '');
        setSelectedSpendVolumes(numericValue);
    };

    const onSericeRegionSelect = (e) => {
        setSelectedServiceRegion(e);
    };

    const onImplementationDateChanges = (e) => {
        setImplementationDate(e);
        setSelectedImplementationStartDate(formatInputDate(e));
    };

    const onProjectedProductionDateChanges = (e) => {
        setProjectedProductionDate(e);
        setSelectedProjectedProductionDate(formatInputDate(e));
    };

    const onActualProductionDateChanges = (e) => {
        setActualProductionDate(e);
        setSelectedActualProductionDate(formatInputDate(e));
    };


    function formatDateTime(dateTime) {
        if (dateTime) {
            return new Date(dateTime).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return '';
    }


    const handleViewChange = (e) => {
        // Handle changes in the displayed view (e.g., month, year, decade)
        console.log('View changed:', e);
    };

    return (
        <>


            <div className='col-12 mt-2  ps-2 pe-2'>

                <div className='row'>

                    {/* <div className='col-4 col-xs-12 mt-2 mb-2 pe-0'>
                        <div className='row g-0 mb-2'>
                            <div className='col-4 col-xs-12'>
                                <label>Owner:</label>
                            </div>
                            <div className='col-8 col-xs-12'>
                                NvisionGlobal
                            </div>
                        </div>
                    </div> */}

                    <div className='col-4 col-xs-12 mt-2 mb-2 pe-0'>
                        <div className='row g-0 mb-2'>
                            <div className='col-5 col-xs-12'>
                                <label>Customer:</label>
                            </div>
                            <div className='col-md-7 col-xs-12'>
                                {props.detailData && (
                                    <span>{props.detailData.customerName}</span>
                                )}
                            </div>
                        </div>
                    </div>

                </div>

                <div className='row border-top vertical-sub'>
                    <div className='col-12'>
                        <div id="error" class="text-danger"></div>
                    </div>

                    <div className='col-6 col-xs-12 mt-2 mb-2 pe-0'>
                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Location Type:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-8 col-xs-12'>
                                <SelectSearch
                                    id="ddnLocationType"
                                    name="ddnLocationType"
                                    value={selectedLocationType}
                                    options={props.locationType}
                                    onChange={onLocationTypeSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>
                            </div>
                        </div>

                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Location Name:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-8 col-xs-12'>

                                <SelectSearch
                                    id="ddnLocationName"
                                    name="ddnLocationName"
                                    value={selectedLocationName}
                                    options={locationNameOptions}
                                    onChange={onLocationNameSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>

                            </div>
                        </div>

                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Type of Service:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-8 col-xs-12'>

                                <SelectSearch
                                    id="ddnServiceType"
                                    name="ddnServiceType"
                                    value={selectedServiceType}
                                    options={props.serviceType}
                                    onChange={onServiceTypeSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>

                            </div>
                        </div>

                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Funding Type:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-8 col-xs-12'>

                                <SelectSearch
                                    id="ddnFundingType"
                                    name="ddnFundingType"
                                    value={selectedFundingType}
                                    options={props.fundingType}
                                    onChange={onFundingTypeSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>

                            </div>
                        </div>
                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Sales Person:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-8 col-xs-12'>
                                <input
                                    id="inpSalesPerson"
                                    className='form-control form-control-sm'
                                    value={selectedSalesPerson}
                                    onChange={onSalesPersonChange}
                                />
                            </div>
                        </div>
                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Contract Completed:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-4 col-xs-12'>

                                <SelectSearch
                                    id="ddnContractCompleted"
                                    name="ddnContractCompleted"
                                    value={selectedContractCompleted}
                                    options={props.contractCompleted}
                                    onChange={onContractCompletedSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>

                            </div>
                        </div>
                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Contract Date:</label>
                            </div>
                            <div className='col-md-4 col-xs-12'>
                                <DatePicker
                                    id="contractDatePickerId"
                                    // value={selectedContractDate !== null ? new Date(selectedContractDate) : null}
                                    value={contractDate}
                                    onChange={onContractDateChanges}
                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                    format="MM/dd/yyyy"
                                    fixedHeight
                                    openCalendarOnFocus={false}
                                    disabled={isContractDateDisabled}
                                />
                            </div>
                        </div>
                        <div className='row g-0 mb-2'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Created By:</label>
                            </div>
                            <div className='col-md-8 col-xs-12'>
                                <span>{selectedCreatedBy}</span>
                            </div>
                        </div>

                        <div className='row g-0'>
                            <div className='col-md-4 col-xs-12'>
                                <label>Created On:</label>
                            </div>
                            <div className='col-md-8 col-xs-12'>
                                <span>{formatDateTime(selectedCreatedOn) || ''}</span>
                            </div>
                        </div>





                    </div>

                    <div className='col-6 col-xs-12 ps-5 pe-2 mt-2 mb-2'>
                        <div className='row mb-2'>
                            <div className='col-md-7 col-xs-12'>
                                <label>Projected Freight Bill Volumes:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <input
                                    id="inpFreightBillVolumes"
                                    className='form-control form-control-sm'
                                    value={selectedProjectedVolumes !== null ? selectedProjectedVolumes : ''}
                                    onChange={onProjectedVolumesChanges}
                                    style={{ textAlign: 'right' }} />
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-7 col-xs-12 pe-0'>
                                <label>Projected Freight Spend Volume:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <input
                                    id="inpFreightBillSpendVolumes"
                                    className='form-control form-control-sm'
                                    value={selectedSpendVolumes !== null ? selectedSpendVolumes : ''}
                                    onChange={(e) => {
                                        onProjectedSpendChanges(e);
                                    }}
                                    style={{ textAlign: 'right' }}
                                />
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-7 col-xs-12'>
                                <label>Region of nVision Service:<label className="text-danger">*</label></label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <SelectSearch
                                    id="ddnServiceRegion"
                                    name="ddnServiceRegion"
                                    value={selectedServiceRegion}
                                    options={props.serviceRegion}
                                    onChange={onSericeRegionSelect}
                                    search
                                    filterOptions={fuzzySearch}
                                >
                                </SelectSearch>
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-7 col-xs-12'>
                                <label>Implementation Start Date:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <DatePicker
                                    // value={selectedImplementationStartDate !== null ? new Date(selectedImplementationStartDate) : null}
                                    value={implementationDate}
                                    onChange={onImplementationDateChanges}
                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                    format="MM/dd/yyyy"
                                    fixedHeight
                                    openCalendarOnFocus={false}
                                />
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-7 col-xs-12'>
                                <label>Projected Production Date:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <DatePicker
                                    // value={selectedProjectedProductionDate !== null ? new Date(selectedProjectedProductionDate) : null}
                                    value={projectedProductionDate}
                                    onChange={onProjectedProductionDateChanges}
                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                    format="MM/dd/yyyy"
                                    fixedHeight
                                    openCalendarOnFocus={false}
                                />
                            </div>
                        </div>

                        <div className='row mb-3'>
                            <div className='col-md-7 col-xs-12'>
                                <label>Actual Production Date:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <DatePicker
                                    // value={selectedActualProductionDate !== null ? new Date(selectedActualProductionDate) : null}
                                    value={actualProductionDate}
                                    onChange={onActualProductionDateChanges}
                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                    format="MM/dd/yyyy"
                                    fixedHeight
                                    openCalendarOnFocus={false}
                                />

                            </div>
                        </div>




                        <div className='row mb-2' style={{paddingTop:'27px'}}>
                            <div className='col-md-7 col-xs-12'>
                                <label>Modified By:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0'>
                                <span>{selectedModifiedBy}</span>
                            </div>
                        </div>

                        <div className='row mb-2 '>
                            <div className='col-md-7 col-xs-12'>
                                <label>Modified On:</label>
                            </div>
                            <div className='col-md-5 col-xs-12 ps-0 pe-0'>
                                <span>{formatDateTime(selectedModifiedOn) || ''}</span>
                            </div>
                        </div>

                    </div>



                </div>


                <div className='row'>

                    <div className='col-12 mt-2 text-center'>
                        <div className="form-field mx-auto">
                            {/* <button type="button" onClick={{}} className='btn btn-clear'>Cancel</button> */}
                            <button type="button" className='btn btn-filter ms-2' onClick={handleSave}>Save</button>
                            <button type='button' className='btn btn-clear ms-2' onClick={handleCancel}> Cancel</button>
                        </div>

                    </div>

                </div>

            </div>



        </>
    );
}

